var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quantity-wrapper"},[_c('div',{staticClass:"action-quantity"},[_c('Quantity',{class:( _obj = {}, _obj["in-cart"] = _vm.isInCart, _obj ),attrs:{"value":_vm.quantity,"type":_vm.type,"change-handler":_vm.changeHandler,"tooltip-text":_vm.tooltipText,"max":_vm.max}}),_c('div',{class:["buttons-wrapper"]},[_vm._t("buttons")],2)],1),_vm._t("under")],2)}
var staticRenderFns = []

export { render, staticRenderFns }